export const latestTermsSignedEndpoint = (userId) => {
    return {
        options: {
            method: "GET",
        },
        url: `/brand-terms-latest/user/${userId}`,
    };
};
